import * as React from 'react';

import { UitkText } from 'uitk-react-text';
import { Phrase } from 'components/shared/phrase';
import { PhraseType } from 'types/shared/phrase';

interface FlightPriceProps {
  price: PhraseType;
}

enum PriceClassMap {
  STANDARD = 'uitk-type-heading-300',
  IMPORTANT = 'uitk-type-heading-600'
}

export const FlightPrice = ({ price }: FlightPriceProps) => {
  const { items } = price;
  const priceClass = PriceClassMap[items[0].styles[0]];

  return (
    <UitkText className={priceClass}>
      <Phrase {...price} />
    </UitkText>
  );
};
